export const isAuditCommentsRequired = () => {
  return process.env.REACT_APP_IS_AUDIT_COMMENTS_REQUIRED !== "false";
};
